module.exports = __webpack_public_path__ + "static/media/reset.572e6aab.svg";